var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"main__column main__column--wide shiftUp"},[(_vm.form === 'upload')?_c('FileUpload',{on:{"toggleForm":_vm.toggleForm}}):_vm._e(),_vm._v(" "),(_vm.form === 'paste')?_c('FilePaste',{on:{"toggleForm":_vm.toggleForm}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }